import { HeaderDetailsContext } from '@shared/header/header-details.context';
import { useContext } from 'react';

/**
 * @deprecated use <Seo /> instead
 */
export const useHeaderDetails = () => {
  return useContext(HeaderDetailsContext);
};
